import { useSelector } from 'react-redux';

interface KiCodeAccessState {
  authentication?: {
    access?: {
      sections?: {
        settings_section?: {
          ai_business_generation?: { edit?: boolean | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
}

const selectKiCodeAccess = (state: KiCodeAccessState): boolean =>
  state.authentication?.access?.sections?.settings_section
    ?.ai_business_generation?.edit === true;

/**
 * KiCode requires the AI Business Builder create/edit permission, strictly
 * `true`.
 */
export const useKiCodeAccess = (): boolean => useSelector(selectKiCodeAccess);
